import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { ldGetFlag } from 'lib/launchDarkly/ldGetFlag'
import { browserName } from 'lib/bowser'

import {
  ADD_FROM_BABYLIST_STORE,
  ADD_BABYLIST_BUTTON,
  INSTALL_BABYLIST_APP,
  INSTALL_BABYLIST_EXTENSION,
} from 'registry/constants'
import {
  getRegistryId,
  getRegistryOwnerId,
  getBabylistButtonAdded,
  getBabylistExtensionInstalled,
} from 'registry/reducers'
import { setActiveModal } from 'registry/actions'
import fetch from 'lib/fetch'
import css from './feed-items.scss'
import { SectionHeading } from '../../../../components/headings'
import { AddItemsCardTile } from './add-items-card-tile'
import {
  FEED_BRANDS_DATA_API_URL,
  FEED_STORES_DATA_API_URL,
} from '../../../constants'
import { TYPE } from '../feed-item-layout'

class AddItemsCard extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      cards: [],
    }

    this.handleCardClick = this.handleCardClick.bind(this)
  }

  componentDidMount() {
    const { type } = this.props
    let dataUrl = ''
    switch (type) {
      case TYPE.ADD_ITEMS:
        dataUrl = FEED_STORES_DATA_API_URL
        break
      case TYPE.ADD_ITEMS_BRANDS:
        dataUrl = FEED_BRANDS_DATA_API_URL
        break
      default:
        dataUrl = ''
    }

    if (!dataUrl) return

    fetch(dataUrl).then((data) =>
      this.setState({ cards: data.stores || data.data || [] })
    )
  }

  handleCardClick(modalToOpen, modalProps) {
    const { setActiveModal } = this.props
    return () => setActiveModal(modalToOpen, modalProps)
  }

  render() {
    const {
      title,
      type,
      registryId,
      registryOwnerId,
      user,
      addedBabylistButton,
      installedBabylistExtension,
    } = this.props
    const { isMobile } = this.context
    const { cards } = this.state

    const platformModal = isMobile ? INSTALL_BABYLIST_APP : ADD_BABYLIST_BUTTON
    const isStoreCard = type === TYPE.ADD_ITEMS

    const isInDayZeroDesktopExperiment =
      browserName === 'Chrome' &&
      ldGetFlag('24bExDayzeroDesktopExtensionV2', 'control', true) ===
        'variation1'
    const trackingData = {
      registryId,
      registryOwnerId,
      currentUserId: user.id,
      isStoreCard,
    }

    if (!cards.length) return <></>

    const getModalNameToShow = (card) => {
      const isBabylistStoreCard =
        isStoreCard && card.url.includes('www.babylist.com')

      if (isBabylistStoreCard) {
        return ADD_FROM_BABYLIST_STORE
      }

      if (isMobile) {
        return INSTALL_BABYLIST_APP
      }

      if (installedBabylistExtension || addedBabylistButton) {
        // Bypass the modal entirely if we recognize a user has already installed the extension or bookmarklet
        return undefined
      }

      if (isInDayZeroDesktopExperiment) {
        return INSTALL_BABYLIST_EXTENSION
      }

      return ADD_BABYLIST_BUTTON
    }

    const getCardActionProps = (card) => {
      const modalName = getModalNameToShow(card)

      if (modalName) {
        return {
          onClick: this.handleCardClick(modalName, {
            storeName: card.name,
            storeUrl: card.url,
          }),
        }
      }

      return { url: card.url }
    }

    return (
      <div className={classNames(css.addItemsLayout, 'mbxl')}>
        <SectionHeading className="h2 text-bold mbl mll">
          {title}
        </SectionHeading>
        <div className={css.storeGrid}>
          {cards.map((card) => {
            return (
              <AddItemsCardTile
                key={card.name}
                name={card.name}
                img={card.logoImageUrl}
                trackingData={trackingData}
                {...getCardActionProps(card)}
              />
            )
          })}
        </div>
      </div>
    )
  }
}

AddItemsCard.contextTypes = {
  isMobile: PropTypes.bool,
}

AddItemsCard.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  setActiveModal: PropTypes.func.isRequired,
  registryId: PropTypes.number.isRequired,
  registryOwnerId: PropTypes.number.isRequired,
  addedBabylistButton: PropTypes.bool.isRequired,
  installedBabylistExtension: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
  registryId: getRegistryId(state),
  registryOwnerId: getRegistryOwnerId(state),
  addedBabylistButton: getBabylistButtonAdded(state),
  installedBabylistExtension: getBabylistExtensionInstalled(state),
  user: state.user,
})

export default connect(mapStateToProps, { setActiveModal })(AddItemsCard)
